import { ThemeProvider, ThemeCSSVariableProvider, ThemeGlobalStyles, LogoSpinner, Flexbox, CircleSpinner } from '@newfront-insurance/core-ui';
import { GoogleProvider } from '@newfront-insurance/next-gapi';
import React, { Suspense } from 'react';
import { L as LayoutConfigProvider, I as InternalAppErrorBoundary, A as AppHeader, g as getAppTypeMetadata } from '../../dist/types-143ec164.esm.js';
export { b as AppType, E as ErrorBoundaryWithMessages, I as InternalAppErrorBoundary, a as LinkType, P as PageLayout, T as TabIcon, c as bugsMessage } from '../../dist/types-143ec164.esm.js';
import '@babel/runtime/helpers/extends';
import { PermissionError } from '@newfront-insurance/data-layer-client';
import 'react-error-boundary';
export { F as FallbackSuspense } from '../../dist/index-1a39589f.esm.js';
import { hasAnyScope } from '@newfront-insurance/next-auth';
import { useProvider } from '@newfront-insurance/react-provision';
export { I as IDENTITY_TYPE_LABELS, d as getBusinessIdentifierLabel, a as getStructuredDataArrayField, g as getStructuredDataTextField, h as hasAnyAccountViewAccessScopes } from '../../dist/format-account-f3e79b24.esm.js';
import '@newfront-insurance/core';
import '@newfront-insurance/string-formatters';
import '@newfront-insurance/next-router-provider';
import 'styled-components';
import '@newfront-insurance/auth-api';
import 'react-use-hoverintent';
import '@newfront-insurance/account-api';
import '@newfront-insurance/next-api-swr';
import '@newfront-insurance/coverage-api';
import '../../dist/use-policy-1760ed5d.esm.js';
import '@newfront-insurance/dsl-schema-ui';
import '@newfront-insurance/core-money';
import '@newfront-insurance/next-notifications';
import 'react-use';
import '../../dist/trpc-2b4d7b2f.esm.js';
import 'formik';
import 'lodash/get';
import '../../dist/line-of-coverage-851873c4.esm.js';
import 'pluralize';
import 'yup';
import '@newfront-insurance/spreadsheet';
import '@newfront-insurance/spreadsheet/dist/src/components/table/popover';
import 'lodash/find';
import 'lodash/uniqBy';
import '../../dist/schemas-21e94256.esm.js';
import 'lodash/debounce';
import '@newfront-insurance/account-common';
import '@newfront-insurance/users-api';
import 'tiny-invariant';
import 'fuse.js';
import 'lodash.noop';
import 'smartystreets-javascript-sdk';
import '../../dist/smarty-street-public-key-85081a7e.esm.js';
import 'postal-codes-js';
import 'react-highlight-words';
import 'swr';
import 'urlcat';

/**
 * Add this provider to _app to enable the use of all of the hooks.
 */
function AdminLayoutProvider(props) {
  const {
    apiBasePath,
    children,
    googleClientId,
    authProvider,
    currentApp,
    legacyAppBaseUrl,
    logoutRedirect,
    onError,
    isBillingAppEnabled
  } = props;
  return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(ThemeCSSVariableProvider, null, /*#__PURE__*/React.createElement(ThemeGlobalStyles, null, /*#__PURE__*/React.createElement(LayoutConfigProvider, {
    authProvider: authProvider,
    apiBasePath: apiBasePath,
    currentApp: currentApp,
    legacyAppBaseUrl: legacyAppBaseUrl,
    logoutRedirect: logoutRedirect,
    onError: onError,
    isBillingAppEnabled: isBillingAppEnabled
  }, /*#__PURE__*/React.createElement(GoogleProvider, {
    clientId: googleClientId
  }, children)))));
}

function AppLayout(props) {
  const {
    children,
    homeRoute,
    leftToolbar,
    rightToolbar
  } = props;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LogoSpinner, null)
  }, /*#__PURE__*/React.createElement(InternalAppErrorBoundary, null, /*#__PURE__*/React.createElement(Flexbox, {
    flexDirection: "column",
    width: "100vw",
    style: {
      overflow: 'hidden',
      height: '100vh'
    }
  }, /*#__PURE__*/React.createElement(AppHeader, {
    homeRoute: homeRoute,
    leftToolbar: leftToolbar,
    rightToolbar: rightToolbar
  }), /*#__PURE__*/React.createElement(InternalAppErrorBoundary, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(CircleSpinner, null)
  }, children)))));
}

/**
 * This is a boundary that will render a fallback message if the logged in user
 * does not have access to the current app.
 */
function AppPermissionBoundary(_ref) {
  let {
    children
  } = _ref;
  const {
    authProvider,
    currentApp
  } = useProvider(LayoutConfigProvider);
  const {
    userDetails: user
  } = useProvider(authProvider);
  const {
    scopes: allowedScopes
  } = getAppTypeMetadata(currentApp);
  const isAllowed = user && hasAnyScope(user.scopes, allowedScopes);

  if (!isAllowed) {
    throw new PermissionError('You do not have permission to access this page.');
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}

export { AdminLayoutProvider, AppLayout, AppPermissionBoundary };
